import * as React from "react";
import { createComponent } from "@lit/react";
import Component from "../../components/Card/sgds-card";
import { register } from "../../utils/ce-registry";

register("sgds-card", Component);

export default createComponent({
  react: React,
  tagName: "sgds-card",
  elementClass: Component,
  events: {}
});
